import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MtlParserService {
  private textureKeywords = [
    'map_Ka',
    'map_Kd',
    'map_Ks',
    'map_Ns',
    'map_d',
    'map_Bump',
    'bump',
    'disp',
    'decal',
    'refl'
  ];

  async parseFile(file: File): Promise<string[]> {
    const text = await file.text();
    return this.parseText(text);
  }

  parseText(text: string): string[] {
    const lines = text.split(/\r?\n/);
    const textures: Set<string> = new Set();

    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) continue;

      for (const key of this.textureKeywords) {
        if (trimmed.startsWith(key + ' ')) {
          const parts = trimmed.split(/\s+/).slice(1); // remove keyword
          if (parts.length === 0) continue;
          const path = parts[parts.length - 1];
          const filename = path.split(/[\\/]/).pop();
          if (filename) textures.add(filename);
          break;
        }
      }
    }
    return Array.from(textures);
  }
}
